export const returnCategoryTranslation = (t, category) => {
	switch (category) {
		case "Cash":
			return t("cash");
		case "Real Estate":
			return t("realEstate");
		case "Vehicles":
			return t("vehicles");
		case "Valuables":
			return t("valuables");
		case "Other":
			return t("other");
		case "Mortgage":
			return t("mortgage");
		case "Credit Card":
			return t("creditCard");
		case "Car Loan":
			return t("carLoan");
		case "Student Loan":
			return t("studentLoan");
		default:
			return t("unknownCategory");
	}
};
